<template>
  <el-form
    ref="addTask"
    :model="addFrom"
    :rules="rules"
    label-width="0px"
    class="reviewer-from"
  >
    <el-row>
      <el-col :span="24">
        <el-form-item label prop="columnId">
          <div class="table">
            <div class="table-header">
              <div>审核序号</div>
              <div>审核人</div>
              <div>审核人岗位</div>
              <div>
                操作
                <div @click="handleAddTd">+</div>
              </div>
            </div>
            <div class="table-body" v-if="shrList && shrList.length > 0">
              <div
                class="table-tr"
                v-for="(item, index) in shrList"
                :key="item.id"
              >
                <div class="table-td">{{ index + 1 }}</div>
                <div class="table-td">
                  <treeselect
                    v-model="item.ygbh"
                    placeholder="请选择"
                    :options="deptUser"
                    :disable-branch-nodes="true"
                    :show-count="true"
                    value-consists-of="LEAF_PRIORITY"
                    no-results-text="未搜到任何结果"
                    :clear-on-select="true"
                    :normalizer="normalizer"
                    style="width: 200px"
                    size="small"
                    @select="handleSelectYg"
                  />
                </div>
                <div class="table-td">{{ item.gwmc }}</div>
                <div class="table-td del" @click="handleDelTd(item.id)">
                  删除
                </div>
              </div>
            </div>
            <div v-else class="table-none">暂无数据</div>
          </div>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row class="uploadButton">
      <el-button @click="hideDialog()">取消</el-button>
      <el-button type="primary" @click="handleEdit()">提交</el-button>
    </el-row>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";

import { getCgwReviewerById } from "@/api/cgw.js";

export default {
  name: "add",
  computed: {
    ...mapGetters(["deptUser"]),
  },
  components: { Treeselect },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      addFrom: {
        txlx: null,
        jdlx: null,
        txlx: null,
        name: null,
        sun: null,
        bmbh: null,
        id: null,
        bz: null,
      },

      rules: {},
      ygtxoptions: [],
      shrList: [],
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    getCgwReviewerById(this.mxParams.rlId).then((res) => {
      if (res.code == 0) {
        this.shrList = res.data;
        for (let i in this.shrList) {
          this.shrList[i].ygbh = this.shrList[i].ygbh;
        }
      }
    });
  },
  methods: {
    hideDialog() {
      this.$emit("hideDialog");
    },
    handleEdit() {
      let reviewer = [];
      for (let i of this.shrList) {
        if (i.ygbh) {
          reviewer.push(i.ygbh);
        }
      }
      var newArr = [...new Set(reviewer)]; //利用了Set结构不能接收重复数据的特点
      if (newArr.length === 0) {
        this.$message.error("请至少选择一个审核人！");
        return;
      }
      reviewer = newArr.toString();
      this.$store
        .dispatch("cgw/updateCgwReviewerAction", {
          taskId: this.mxParams.taskId,
          rlId: this.mxParams.rlId,
          reviewer: reviewer,
          rwmc: this.mxParams.rwmc,
        })
        .then((success) => {
          if (success.code === 0) {
            this.$message.success("保存成功!");
            this.$emit("hideDialog");
            this.$emit("getList");
          } else {
            this.$message.error(success.msg);
          }
        });
    },
    handleAddTd() {
      const len = this.shrList.length;
      if (len == 0) {
        this.shrList.push({ id: 1, ygbh: null, gwmc: null });
      } else {
        this.shrList.push({
          id: this.shrList[len - 1].id + 1,
          ygbh: null,
          gwmc: null,
        });
      }
    },
    handleDelTd(id) {
      const temp = [];
      for (let i of this.shrList) {
        if (i.id != id) {
          temp.push(i);
        }
      }
      this.shrList = temp;
    },
    handleSelectYg(e) {
      // this.shrList
      setTimeout(() => {
        for (let i in this.shrList) {
          if (this.shrList[i].ygbh == e.ygbh) {
            this.shrList[i].gwmc = e.gwmc;
          }
        }
      }, 50);
    },
  },
};
</script>
<style lang="less" scoped>
.table {
  .table-header {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #f2f2f2;
    display: flex;
    justify-content: center;
    > div {
      width: 20%;
      display: flex;
      justify-content: center;
      > div {
        color: #036eb8;
        padding: 0 10px;
        font-size: 25px;
        cursor: pointer;
      }
    }
    > div:nth-of-type(2) {
      width: 40%;
    }
  }
  .table-none {
    text-align: center;
    color: #999;
    margin: 10px 0;
  }
  .table-body {
    .table-tr {
      display: flex;
      height: 44px;
      line-height: 44px;
      text-align: center;
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #f2f2f2;
      // border-left: 1px solid #f2f2f2;
      .table-td {
        display: flex;
        justify-content: center;
        width: 20%;
        // border-right: 1px solid #f2f2f2;
      }
      .table-td:nth-of-type(2) {
        width: 40%;
      }
      .del {
        color: #ff0000;
        cursor: pointer;
      }
    }
  }
}
.uploadButton {
  text-align: right;
  margin-top: 10px;
}
</style>